import { render } from "./NoticeManager.vue?vue&type=template&id=1dfee71b"
import script from "./NoticeManager.vue?vue&type=script&lang=js"
export * from "./NoticeManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__